import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  PaginatedArticle,
  ChangeUserArticleStatus,
  SetVisibilityArticle,
} from "../../api/ArticleApi/Article";
import { GetUpdateReqContent } from "../../api/ContentApi/contentApi";
import "./UserArticle.css";
import {
  CommonStatus,
  blogVisibilityStatus,
  contentCategoryId,
} from "../../app/Enums/StatusEnums";
import { RoleId } from "../../app/Enums/RoleId";
import BlogActionModal from "../../app/components/FeedbackModal/BlogActionModal/BlogActionModal";
import RejectBlogModal from "../../app/components/FeedbackModal/RejectBlogModal/RejectBlogModal";
import { toast } from "react-toastify";
import { routePath } from "../../app/routes/routepath";
import Pagination from "../../app/components/Pagination/Pagination";
import viewSvg from "../../assets/icons/view.svg";
import {
  Ban,
  CheckCircle,
  ClipboardEdit,
  Clock,
  Eye,
  History,
  Lock,
  Unlock,
} from "lucide-react";

export default function UserArticle() {
  const navigate = useNavigate();
  const [ReceivedDbData, setReceivedDbData] = useState([]);
  const [UpdateReqData, setUpdateReqData] = useState([]);
  const [updateReqDisplay, setUpdateReqDisplay] = useState(false);
  const [Value, setValue] = useState(() => ({
    StatusId:
      Number(localStorage.getItem("articleStatus")) || CommonStatus.Pending,
    PageNo: Number(localStorage.getItem("articlePageNo")) || 1,
    PageSize: Number(localStorage.getItem("articlePageSize")) || 10,
    authorId: 0,
    RoleId: RoleId.User,
  }));
  const [updatePageNo, setUpdatePageNo] = useState(1);
  const [updatePageSize, setUpdatePageSize] = useState(10);
  const [updateTotalRows, setUpdateTotalRows] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const totalPages = Math.ceil(totalRows / Value.PageSize);
  const updateTotalPages = Math.ceil(updateTotalRows / updatePageSize);

  const [dataModal, setdataModal] = useState([]);
  const [actionModal, setactionModal] = useState(false);
  const [showRejectBlogModal, setshowRejectBlogModal] = useState(false);
  const tableRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const roleId = Number(localStorage.getItem("RoleId"));

  useEffect(() => {
    localStorage.setItem("articleStatus", Value.StatusId);
    localStorage.setItem("articlePageNo", Value.PageNo);
    localStorage.setItem("articlePageSize", Value.PageSize);
  }, [Value.StatusId, Value.PageNo, Value.PageSize]);

  useEffect(() => {
    if (Value.StatusId === 5) {
      fetchUpdateArticles(updatePageNo, updatePageSize);
    } else {
      fetchPaginatedArticles();
    }
  }, [Value, updatePageNo, updatePageSize]);

  const fetchPaginatedArticles = async () => {
    try {
      const response = await PaginatedArticle(Value);
      if (response.result === 1) {
        setReceivedDbData(Object.values(response.result_value));
        setTotalRows(response.totalRows);
        setUpdateReqDisplay(false);
      } else {
        toast.error("Failed to fetch articles.");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchUpdateArticles = async (page, size) => {
    try {
      const req = {
        categoryId: contentCategoryId.article,
        statusId: CommonStatus.Pending,
        pageNumber: page,
        pageSize: size,
      };
      const response = await GetUpdateReqContent(req);
      if (response?.data.result == 1) {
        setUpdateReqData(response.data.result_value);
        setUpdateTotalRows(response.data.totalRecords);
        setUpdateReqDisplay(true);
      } else {
        toast.error("Failed to fetch update requests.");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleStatusChange = (e) => {
    const selectedValue = Number(e.target.value);
    if (selectedValue === 5) {
      setUpdateReqDisplay(true);
    } else {
      setUpdateReqDisplay(false);
    }

    setValue((prev) => ({
      ...prev,
      StatusId: selectedValue,
      PageNo: 1,
    }));
  };

  const changeStatus = (data) => {
    setdataModal(data);
    setactionModal(true);
  };

  const handleApproveFromModal = async () => {
    const payload = {
      articleId: dataModal.articleId,
      statusId: CommonStatus.Approved,
      approvedBy: dataModal.authorId,
      rejectResion: null,
    };
    const response = await ChangeUserArticleStatus(payload);
    if (response?.result === 1) {
      toast.success("Article Approved");
      setactionModal(false);
    } else {
      toast.error("Failed to approve");
    }
  };

  const handleRejectFromModal = () => {
    setactionModal(false);
    setshowRejectBlogModal(true);
  };

  const handleRejectWithReason = async (reason) => {
    const payload = {
      articleId: dataModal.articleId,
      statusId: CommonStatus.Rejected,
      approvedBy: null,
      rejectResion: reason,
    };
    try {
      const response = await ChangeUserArticleStatus(payload);
      if (response?.result === 1) {
        toast.success("Article rejected");
      } else {
        toast.error("Failed to reject");
      }
    } catch (err) {
      toast.error("Please try again");
    } finally {
      setshowRejectBlogModal(false);
    }
  };
  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html || "";
    return txt.value;
  };
  const handleEnableDisable = async (articleId, isActive) => {
    const payload = {
      articleId,
      isActive,
    };
    const response = await SetVisibilityArticle(payload);
    if (response?.result === 1) {
      if (isActive == false) {
        toast.success("Blog Disabled Successfully");
      } else {
        toast.success("Blog Enabled Successfully");
      }
      fetchPaginatedArticles();
    } else {
      toast.error("Failed to update visibility");
    }
  };

  const navigateDashboard = () => {
    navigate(routePath.dashboard);
  };

  const handleUpdateReview = (item) => {
    navigate(routePath.UpdateReview, {
      state: { content: item, category: contentCategoryId.article },
    });
  };
  const handleView = (articleId) => {
    navigate(routePath.ViewArticle, {
      state: {
        articleId: articleId,
        returnPath: "/adminArticle",
      },
    });
  };

  useEffect(() => {
    tableRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, [Value]);

  const openModal = (description) => {
    setSelectedDescription(description);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDescription("");
  };

  return (
    <div className="main-out-wraper">
      <div className="main-out-wraper">
        <div className="role-box">
          <h2>User Article</h2>
          <div className="search-filter-section">
            <div className="form-wraper">
              <label>Status</label>
              <select value={Value.StatusId} onChange={handleStatusChange}>
                <option value={CommonStatus.Pending}>Pending</option>
                <option value={CommonStatus.Approved}>Approved</option>
                <option value={CommonStatus.Rejected}>Rejected</option>
                <option value={5}>Update Request</option>
              </select>
            </div>
            <div></div>
          </div>
        </div>

        <div className="main_widget">
          <div className="main_widget_body">
            <div className="table-responsive" ref={tableRef}>
              <table>
                <thead>
                  <tr>
                    <th style={{ minWidth: "47px" }}>S.No</th>
                    <th style={{ minWidth: "430px" }}>Title</th>
                    <th style={{ minWidth: "180px" }}>Cover Image</th>
                    <th style={{ minWidth: "430px" }}>Summary</th>
                    <th style={{ minWidth: "310px" }}>Author</th>
                    {updateReqDisplay ? (
                      <th style={{ minWidth: "200px" }}>Action</th>
                    ) : (
                      <>
                        {Value.StatusId === CommonStatus.Approved && (
                          <th style={{ minWidth: "90px" }}>Status</th>
                        )}
                        {Value.StatusId === CommonStatus.Rejected && (
                          <th style={{ minWidth: "200px" }}>Reject Reason</th>
                        )}
                        {Value.StatusId === CommonStatus.Pending && (
                          <th style={{ minWidth: "90px" }}>Status</th>
                        )}
                      </>
                    )}
                    {!updateReqDisplay && (
                      <th c style={{ minWidth: "200px" }}>
                        Action
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {!updateReqDisplay
                    ? ReceivedDbData.map((item, idx) => (
                        <tr key={idx}>
                          <td>
                            {(Value.PageNo - 1) * Value.PageSize + idx + 1}
                          </td>
                          <td style={{ wordBreak: "break-all" }}>
                            {decodeHtml(item.articleTitle)}
                          </td>
                          <td>
                            <img
                              className="CoverImage"
                              src={item.articleCoverImage}
                            />
                          </td>
                          <td style={{ wordBreak: "break-all" }}>
                            {decodeHtml(item.articleDescription).length > 80 ? (
                              <>
                                {decodeHtml(item.articleDescription).slice(
                                  0,
                                  80,
                                )}
                                ...
                                <span
                                  className="see-more"
                                  onClick={() =>
                                    openModal(
                                      decodeHtml(item.articleDescription),
                                    )
                                  }
                                >
                                  {" "}
                                  See more
                                </span>
                              </>
                            ) : (
                              decodeHtml(item.articleDescription)
                            )}
                          </td>
                          <td>{item.authorName}</td>
                          {Value.StatusId === CommonStatus.Pending &&
                          roleId === RoleId.Admin ? (
                            <td>
                              {/* <button
                            className="label_btn pending_btn"
                            onClick={() => changeStatus(item)}
                          >
                            Pending
                          </button> */}
                              <div
                                className="tooltip-wrapper"
                                style={{ "--bg-color": "#f59e0b" }}
                                onClick={() => changeStatus(item)}
                              >
                                <Clock className="icon icon-pending" />
                                <span className="tooltip-text">Pending</span>
                              </div>
                            </td>
                          ) : (
                            Value.StatusId === CommonStatus.Pending &&
                            roleId === RoleId.SuperAdmin && (
                              <td>
                                <div
                                  className="tooltip-wrapper"
                                  style={{ "--bg-color": "#f59e0b" }}
                                >
                                  <Clock className="icon icon-pending" />
                                  <span className="tooltip-text">Pending</span>
                                </div>
                              </td>
                            )
                          )}
                          {Value.StatusId === CommonStatus.Rejected && (
                            <td>{item.rejectReason}</td>
                          )}
                          {Value.StatusId === CommonStatus.Approved &&
                          roleId === RoleId.Admin ? (
                            <td>
                              {/* <button
                            className={`label_btn ${item.isActive === blogVisibilityStatus.enable
                              ? "disable_btn"
                              : "enable_btn"
                              }`}
                            onClick={() =>
                              handleEnableDisable(
                                item.articleId,
                                item.isActive === blogVisibilityStatus.enable
                                  ? blogVisibilityStatus.disable
                                  : blogVisibilityStatus.enable
                              )
                            }
                          >
                            {item.isActive === blogVisibilityStatus.enable
                              ? "Disable"
                              : "Enable"}
                          </button> */}
                              {item.isActive === blogVisibilityStatus.enable ? (
                                /* DISABLE */
                                <div
                                  className="tooltip-wrapper"
                                  style={{ "--bg-color": "#dc2626" }}
                                  onClick={() =>
                                    handleEnableDisable(
                                      item.articleId,
                                      blogVisibilityStatus.disable,
                                    )
                                  }
                                >
                                  <Unlock className="icon icon-approved" />
                                  <span className="tooltip-text">Disable</span>
                                </div>
                              ) : (
                                /* ENABLE */
                                <div
                                  className="tooltip-wrapper"
                                  style={{ "--bg-color": "#22c55e" }}
                                  onClick={() =>
                                    handleEnableDisable(
                                      item.articleId,
                                      blogVisibilityStatus.enable,
                                    )
                                  }
                                >
                                  <Lock className="icon icon-deactivated" />
                                  <span className="tooltip-text">Enable</span>
                                </div>
                              )}
                            </td>
                          ) : (
                            Value.StatusId === CommonStatus.Approved &&
                            roleId === RoleId.SuperAdmin && (
                              <td>
                                {item.isActive ===
                                blogVisibilityStatus.enable ? (
                                  // <strong id="EnableVisibility">
                                  //   Active
                                  // </strong>
                                  <div
                                    id="EnableVisibility"
                                    className="tooltip-wrapper"
                                    style={{ "--bg-color": "#16a34a" }}
                                  >
                                    <CheckCircle className="icon icon-active" />
                                    <span className="tooltip-text">Active</span>
                                  </div>
                                ) : (
                                  // <strong id="DisableVisibility">
                                  //   InActive
                                  // </strong>
                                  <div
                                    id="DisableVisibility"
                                    className="tooltip-wrapper"
                                    style={{ "--bg-color": "#ef4444" }}
                                  >
                                    <Ban className="icon icon-deactivated" />
                                    <span className="tooltip-text">
                                      Inactive
                                    </span>
                                  </div>
                                )}
                              </td>
                            )
                          )}
                          <td>
                            <div
                              className="tooltip-wrapper"
                              style={{ "--bg-color": "#002954" }}
                              onClick={() => handleView(item.articleId)}
                            >
                              <Eye className="icon icon-view" />
                              <span className="tooltip-text">View Article</span>
                            </div>
                            {/* <img className="table-icon" onClick={() => handleView(item.articleId)} src={viewSvg} alt="view" /> */}
                          </td>
                        </tr>
                      ))
                    : UpdateReqData.map((item, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td style={{ wordBreak: "break-all" }}>
                            {item.updatedTitle}
                          </td>
                          <td>
                            <img
                              className="CoverImage"
                              src={item.updatedCoverImage}
                            />
                          </td>
                          <td style={{ wordBreak: "break-all" }}>
                            {decodeHtml(item.updatedDescription).length > 80 ? (
                              <>
                                {decodeHtml(item.updatedDescription).slice(
                                  0,
                                  80,
                                )}
                                ...
                                <span
                                  className="see-more"
                                  onClick={() =>
                                    openModal(
                                      decodeHtml(item.updatedDescription),
                                    )
                                  }
                                >
                                  {" "}
                                  See more
                                </span>
                              </>
                            ) : (
                              decodeHtml(item.updatedDescription)
                            )}
                          </td>
                          <td>{item.userName}</td>
                          <td>
                            {/* <button
                          className="label_btn pending_btn"
                          onClick={() => handleUpdateReview(item)}
                        >
                          Review Update
                        </button> */}
                            <div
                              className="tooltip-wrapper"
                              style={{ "--bg-color": "#2563eb" }}
                              onClick={() => handleUpdateReview(item)}
                            >
                              <ClipboardEdit className="icon icon-review-update" />
                              <span className="tooltip-text">
                                Review Update
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}

                  {!updateReqDisplay && ReceivedDbData.length === 0 && (
                    <tr>
                      <td colSpan="7" style={{ textAlign: "center" }}>
                        No articles found
                      </td>
                    </tr>
                  )}

                  {updateReqDisplay && UpdateReqData.length === 0 && (
                    <tr>
                      <td colSpan="7" style={{ textAlign: "center" }}>
                        No update requests found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {actionModal && (
        <BlogActionModal
          onClose={() => setactionModal(false)}
          onApprove={handleApproveFromModal}
          onReject={handleRejectFromModal}
          blogTitle={dataModal.articleTitle || dataModal.updatedTitle}
        />
      )}

      {showRejectBlogModal && (
        <RejectBlogModal
          onClose={() => setshowRejectBlogModal(false)}
          onSubmit={handleRejectWithReason}
          blogTitle={dataModal.articleTitle || dataModal.updatedTitle}
        />
      )}

      {!updateReqDisplay ? (
        <Pagination
          currentPage={Value.PageNo}
          totalPages={totalPages}
          pageSize={Value.PageSize}
          onPageChange={(page) =>
            setValue((prev) => ({ ...prev, PageNo: page }))
          }
          onPageSizeChange={(size) =>
            setValue((prev) => ({ ...prev, PageSize: size, PageNo: 1 }))
          }
        />
      ) : (
        <Pagination
          currentPage={updatePageNo}
          totalPages={updateTotalPages}
          pageSize={updatePageSize}
          onPageChange={setUpdatePageNo}
          onPageSizeChange={(size) => {
            setUpdatePageSize(size);
            setUpdatePageNo(1);
          }}
        />
      )}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
            <h2>Summary</h2>
            <div className="description-container">
              <p>{decodeHtml(selectedDescription)}</p>{" "}
            </div>
            <div className="d-flex justify-content-center">
              <button className="primary_btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
